import apiClient from '@/services/axios'
import { getRoutingSessionId } from '@/services/routing-session'

function withRoutingSession(payload) {
  const sessionId = getRoutingSessionId()
  if (!sessionId) return payload
  return { ...payload, routingSessionId: sessionId }
}

export function getSpecializedRoutings(query) {
  return apiClient.get(`/specialized-routings`, {
    params: query,
  })
}

export function createSpecializedRouting(specializedRouting) {
  return apiClient.post('/specialized-routings', specializedRouting)
}

export function updateSpecializedRouting({ id, ...specializedRouting }) {
  return apiClient.patch(
    `/specialized-routings/${id}`,
    withRoutingSession(specializedRouting),
  )
}

export function updateSpecializedStop({ id, ...specializedStop }) {
  return apiClient.patch(
    `/specialized-stops/${id}`,
    withRoutingSession(specializedStop),
  )
}

export function createSpecializedStop(specializedStop) {
  return apiClient.post(`/specialized-stops`, withRoutingSession(specializedStop))
}

export function getSpecializedRoutingById(id) {
  return apiClient.get(`/specialized-routings/${id}`)
}

export function deleteSpecializedRouting(id) {
  return apiClient.delete(`/specialized-routings/${id}`)
}

// Update specialized routing state (status, tags, etc.)
export function updateSpecializedRoutingState({ id, ...payload }) {
  return apiClient.patch(`/specialized-routings/state/${id}`, payload)
}

export function getSpecializedRoutingVersions(id) {
  return apiClient.get(`/specialized-routings/${id}/versions`)
}

export function getSpecializedRoutingVersion(id, versionNumber) {
  return apiClient.get(`/specialized-routings/${id}/versions/${versionNumber}`)
}

export function startSpecializedRoutingEditSession(id, sessionId) {
  return apiClient.post(`/specialized-routings/${id}/sessions`, { sessionId })
}